import { csvw_url } from "../../components/config";
let a =
{
  title: "",
  titleEn: "",
  subtitle: "",
  subtitleEn: "",
  dec: "",
  decEn: "",
  img: "",
  imgMobile: "",
  list: [],
}
let b =
{
  title: "",
  titleEn: "",
  dec: "",
  decEn: "",
}
export default {
  title: "可持续城市和社区",
  titleEn: "Sustainable Cities and Communities",
  btn: [
    // {
    //   title: "支持文化、艺术事业发展",
    //   titleEn: "Cultural and artistic undertakings",
    //   subtitle: "",
    //   subtitleEn: "",
    //   dec: "上汽大众积极参与支持各类文化事业和产业发展，参与先进文化传播，弘扬社会正能量，以实际行动支持社会文化事业发展。",
    //   decEn: "SAIC Volkswagen plays an active role in cultural undertakings and industry development. We’re engaged in the dissemination of progressive culture and positive social energy, supporting the development of social and cultural undertakings with concrete actions.",
    //   img: require("../../assets/csr/imgs/Stu1@2x.png"),
    //   imgMobile: require("../../assets/csr/imgsMobile/MStu1@2x.png"),
    //   list: [
    //     {
    //       title: "支持“华鼎奖”",
    //       titleEn:
    //           "Sponsorship for Huading Awards",
    //       dec:
    //           "自2007年以来，上汽大众就开始了与“华鼎奖”的跨界合作，共同见证了国内影视行业的发展。2021年，第32届华鼎奖上汽大众威然之夜以“集聚中华民族伟大复兴与中国梦的磅礴力量”为主题，发布了中国百强电视剧满意度提名榜单，鼓舞全球演艺名人的公益和创作精神，也藉此表扬对社会责任有杰出贡献的演艺界人士。",
    //       decEn:
    //           "SAIC Volkswagen has been engaged in cross-border cooperation with the Huading Awards since 2007, witnessing the development of the Chinese film and television industry. At the 32nd Huading Awards SAIC Volkswagen Night in 2021, with the theme of “Gathering the mighty power of the great rejuvenation of the Chinese nation and the Chinese dream”, the nomination list of China’s top 100 TV dramas was unveiled, inspiring global performers to engage in public welfare and creation, while awarding those with outstanding contributions to social responsibility.",
    //     },
    //     {
    //       title: "“了不起的征途”重走红色路线",
    //       titleEn:
    //           "“The Great Journey” event",
    //       dec:
    //           "2021年，上汽大众作为全球合作伙伴支持新华网策划的“了不起的征途”活动。活动以上汽大众全新途昂家族组成的车队为载体，伴随栏目组重走红色发展路线，探索历史革命精神与现代化社会发展的同时，也走进了上汽大众援助的希望小学，让更多社会公众通过“了不起的征途”的镜头走近乡村学校，关注乡村教育。",
    //       decEn:
    //           "In 2021, SAIC Volkswagen, as a global partner, sponsored the “The Great Journey” event planned by Xinhuanet.com. The shooting crew walked along the red development route once more, this time with a fleet made up of the new Teramont family. While exploring the historical revolutionary spirit and modern social development, they also visited the Hope Primary Schools assisted by SAIC Volkswagen, allowing more people to have a better understanding of rural schools and pay greater attention to rural education.",
    //     },
    //   ]
    // },
    {
      title: "支持体育事业发展",
      titleEn: "Sports Events",
      subtitle: "",
      subtitleEn: "",
      dec: " 丰富的文化体育生活，是社会均衡发展和大众生活精神需求不可或缺的部分，也是推动经济发展的新生力量。上汽大众一直关注文体事业的发展繁荣，结合自身企业优势，连续多年支持国内外各大顶级汽车、体育和电竞赛事，为文体爱好者提供实现梦想的平台，推动国内文体事业的不断发展。",
      decEn: "A rich cultural and sports life is an integral part of the balanced development of society and the spiritual needs of the general public. It is also a new, driving force for economic development. SAIC VOLKSWAGEN has always attached great importance to the development and progress of sports and culture. In combination with our corporate strengths, SAIC VOLKSWAGEN has supported major domestic and international top-tier automotive, sports and e-sports events for years. We provide a platform for sports and culture enthusiasts to realize their dreams while promoting the continuous development of sports and culture in China.",
      img: require("../../assets/csr/imgs/Stu2@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MStu2@2x.png"),
      img2: "",
      imgMobile2: "",
      list: [
		{
		  title: "支持“KPL王者荣耀职业联赛”",
		  titleEn:
		      "Sponsorship for KPL (King Pro League)",
		  dec:
		      "一直以来，上汽大众积极关注“全民电竞”事业。2018年起，上汽大众便与KPL王者荣耀职业联赛展开合作。2022年，上汽大众携凌渡L在端内举办了两期“潮辣杯”主题赛，合计参赛人次近2,000万，领奖人次超2,200万。",
		  decEn:
		      "SAIC VOLKSWAGEN has always been paying close attention to the national e-sports industry. From 2018 on, SAIC VOLKSWAGEN has started to collaborate with the King Pro League (KPL). In 2022, SAIC VOLKSWAGEN and Lamando L held two “Hot Cup” tournaments, with nearly 20 million participants and over 22 million prizes awarded.",
		},
        {
          title: "支持“CTCC中国房车锦标赛”",
          titleEn:
              "Sponsorship for CTCC (China Touring Car Championship)",
          dec:
              "上汽大众与中国第一赛车运动品牌CTCC多年合作，致力于推动中国赛车运动及文化的发展。2022年，公司派出全新战车凌渡L，并与四位冠军级职业车手合作，征战2022赛季CTCC中国汽车场地职业联赛，在超级杯组赛事角逐之中获得多个分站冠军、车手年度总冠军的佳绩。同时，通过直播、互动访谈、汽车与赛车知识讲解等方式，为中国汽车行业及汽车运动的文化普及做出贡献。据统计，本次赛事共有2.7亿人次收听收看。",
          decEn:
              "With years of cooperation with China’s No.1 motorsport brand CTCC, SAIC VOLKSWAGEN is committed to promoting the development of motorsports and related culture in China. In 2022, the Company collaborated with four championship-level professional drivers to compete in the 2022 season of the China Touring Car Championship (CTCC) with the brand-new Lamando L cars. They eventually won several race victories in the Super Cup category and secured the championship of the year. At the same time, we contributed to the popularization of the Chinese automotive industry and motorsports culture through live streams, interactive interviews, explanations of automobile and racing knowledge, etc. According to statistics, the event recorded a total of 270 million views.",
        },
        
      ]
    },
    {
      title: "员工志愿者活动",
      titleEn: "Contributing to Culture and Sports Development",
      subtitle: "",
      subtitleEn: "",
      dec: "上汽大众于2009年成立了团委青年志愿者队伍，至今已持续开展志愿服务13年，形成了有体系、有规模、有活力的志愿者队伍。企业将志愿活动与环境保护、社区交流等社会责任主题相结合，在激发员工志愿活力的同时，带动周边社区友好交流、共同发展。",
      decEn: "Since SAIC VOLKSWAGEN established the Youth Volunteer Team under its Chinese Youth League committee in 2019, the Company has been continuously carrying out volunteer services for 13 years, forming a systematic, large-scale and energetic volunteer team. The Company has combined volunteer activities with social responsibility issues such as environmental protection and community exchange, so as to inspire the vitality of employee volunteers while spurring friendly interactions among and common development of the surrounding communities.",
      img: require("../../assets/csr/imgs/Stu4@2x.png"),
      imgMobile: require("../../assets/csr/imgsMobile/MStu4@2x.png"),
      img2: require("../../assets/csr/imgs/Scon1@2x.png"),
      imgMobile2: require("../../assets/csr/imgsMobile/MScon1@2x.png"),
      list: [
		  {
		    title: "上汽大众员工与社区居民携手保护生物多样性",
		    titleEn: "SAIC VOLKSWAGEN employees and community residents work together on biodiversity protection",
		    dec: "2022年12月，上汽大众举办了“零影响工厂——上汽大众2022年志愿者活动”，三十余位志愿者及工厂周边的社区居民走进上汽大众宁波工厂和附近的杭州湾国家湿地公园，观察身边环境的生物多样性状况。",
		    decEn: "In December 2022, SAIC VOLKSWAGEN held the “Zero Impact Factory – 2022 SAIC VOLKSWAGEN Volunteer Event”, where more than 30 volunteers and residents from communities around the factory visited SAIC VOLKSWAGEN Ningbo Factory and the nearby Hangzhou Bay National Wetland Park to observe the biodiversity status of the environment around them.",
		  },
		  {
		    title: "线上环保倡导活动",
		    titleEn: "Protecting the Earth in one hour",
		    dec: "2022年世界地球日（4月22日），上汽大众发起了Project1Hour线上环保倡导活动。有十余位员工积极参与了活动，拍 摄了自己生活中的环保小妙招，通过及时关灯、节约用水、绿色出行、用下厨取代外卖等方式合理使用资源、减少浪费、降低碳排放，从身边小事做起，保护环境，保护地球。",
		    decEn: "On April 22, the world Earth Day, 2022, SAIC VOLKSWAGEN launched the Project1Hour online environmental advocacy campaign. Employees actively took part in the campaign, who filmed videos of their own environmental protection tips in life. They shared ways to use resources wisely andreduce waste and carbon emissions, such as turning off lights in time, saving water, traveling green and home-cook meals in place of takeouts, encouraging to take small steps at home to protect the environment and Earth.",
		  },
	  ],
    },
	
  ]
}
